<app-scrollable-dialog headerKey="passwd.expired" [close]="false">
  <ng-container content>
    {{ 'passwd.changeTitle' | locRep: { $days: PERIOD_OF_VALIDITY } }}
    <ng-container *ngIf="data?.passwordSetDate">
      ({{ 'passwd.lastChange' | loc }}: <i> {{ data.passwordSetDate | lDate: 'dShort' : ('label.never' | loc) }} </i>)
    </ng-container>
    <form [formGroup]="form">
      <app-password-input labelKey="passwd.old" formControlName="oldPassword"> </app-password-input>
      <app-password-input labelKey="passwd.new" formControlName="newPassword" [newPassword]="true"> </app-password-input>
      <app-password-input labelKey="passwd.repeatNew" formControlName="confirmNewPassword" [newPassword]="true">
      </app-password-input>

      <app-password-requirements
        passwordCtrName="newPassword"
        confirmCtrName="confirmNewPassword"
        [reqNew]="true"
        [columns]="4"
      ></app-password-requirements>

      <label> {{ 'passwd.strength' | loc }}: </label>
      <password-strength-meter [password]="form.value.newPassword" [minPasswordLength]="MIN_LENGTH"> </password-strength-meter>
    </form>
    {{ 'passwd.lifeLength' | loc }}: <b>{{ NEW_VALIDITY_DATE | lDate: 'dShort' }}</b>
  </ng-container>
  <ng-container actions>
    <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="submit()">{{ 'button.save' | loc }}</button>
  </ng-container>
</app-scrollable-dialog>
